module.exports = __webpack_public_path__ + "img/social-network-instagram.7eabee15.svg";